import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../../templates/Ui';
const StyledDivider = styled.div `
    position: relative;
    margin: 40px 0;
    background-color: #dbdcdc;
    width: 100%;
    height: 1px;
`;
const Value = styled.div `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${color.body.base};
    padding: 0 50px;
`;
const Divider = ({ value }) => (_jsx(StyledDivider, { children: _jsx(Value, { children: value }) }));
export default Divider;
